export const minBy = (collection, key) => {
    const select = (a, b) => a[key] <= b[key] ? a : b
    return collection.reduce(select, {})
}

export const maxBy = (collection, key) => {
    const select = (a, b) => a[key] >= b[key] ? a : b
    return collection.reduce(select, {})
}

export const uniqBy = (collection: any[], fn: (a: any, b: any) => boolean) => collection.filter((element, index) => collection.findIndex((step) => fn(element, step)) === index);
